/**
 * Created by sivanh on 14/06/18.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var NAME ="ShiftModel";

    var KEYS = {
        START_TIME: "startTime",
        END_TIME: "endTime",
    };

    var EMPTY_STRING = "";

    var ShiftModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ShiftModel = BaseModel.extend({
            KEYS: KEYS,
            name: NAME,
            defaults:{
                id: null,
                startTime: EMPTY_STRING,
                endTime: EMPTY_STRING
            },
            validation:{
                "startTime":[
                    {
                        fn:function () {
                            if (this._isTimeEmpty(KEYS.START_TIME)) {
                                return "LEFramework.entities.scheduling.errors.startDate.required";
                            }
                        }
                    }

                ],
                "endTime":[
                    {
                        fn:function () {
                            if (this._isTimeEmpty(KEYS.END_TIME)) {
                                return "LEFramework.entities.scheduling.errors.endDate.required";
                            }
                        }
                    },
                    {
                        fn:function () {
                            if (!this._isTimeEmpty(KEYS.START_TIME) && !this._isTimeEmpty(KEYS.END_TIME) && !this._isTimeRangeValid()) {
                                return "LEFramework.entities.scheduling.errors.invalidTimeRangeValues";
                            }
                        }
                    }
                ]
            },

            getStartTime: function () {
                return this.get(KEYS.START_TIME);
            },

            getEndTime: function () {
                return this.get(KEYS.END_TIME);
            },

            setStartTime: function (startTime) {
                this.set(KEYS.START_TIME, startTime);
            },

            setEndTime: function (endTime) {
                this.set(KEYS.END_TIME, endTime);
            },

            _isTimeEmpty: function (type) {
                return this.get(type) === EMPTY_STRING;
            },

            _isTimeRangeValid: function () {
                var valid = false;
                var startTime = this.getStartTime();
                var endTime = this.getEndTime();

                var splittedStartTimeToHoursAndMinutes = startTime.split(":");
                var splittedEndTimeToHoursAndMinutes = endTime.split(":");

                var startHours = Number(splittedStartTimeToHoursAndMinutes[0]);
                var endHours = Number(splittedEndTimeToHoursAndMinutes[0]);

                var startMinutes = Number(splittedStartTimeToHoursAndMinutes[1]);
                var endMinutes = Number(splittedEndTimeToHoursAndMinutes[1]);

                if (startHours < endHours ||
                    (startHours === endHours && startMinutes < endMinutes)) {
                    valid = true;
                }
                return valid;
            }

        });

    });


    ShiftModel.NAME = NAME;
    ShiftModel.KEYS = KEYS;

    return ShiftModel;
});
